"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated only used by billing-service plans definitions, but not used anywhere in the app
 * @todo remove this file once it's not used by billing-service anymore
 * @see https://linear.app/shine/issue/COP-1596/%5Bpricingplan%5D-remove-unused-field-type-for-invoicing-and-accounting
 * and https://linear.app/shine/issue/COP-1735/add-logo-in-plans-features
 */
var InvoicingType;
(function (InvoicingType) {
    InvoicingType["Advanced"] = "advanced";
    InvoicingType["Basic"] = "basic";
})(InvoicingType || (InvoicingType = {}));
exports.default = InvoicingType;
